import { useEffect, useRef, useState } from 'react'
import Logo from '../components/Logo'
import './LoadingScreen.css'
import { useLanguage } from '../context/LanguageContext'
import { t } from '../i18n'

const MIN_DISPLAY_MS = 1000
const MAX_DISPLAY_MS = 4200
const FADE_MS = 750

const LoadingScreen = ({ grainientReady = false, onExit }) => {
	const { language } = useLanguage()
	const [pageLoaded, setPageLoaded] = useState(
		document.readyState === 'complete'
	)
	const [exiting, setExiting] = useState(false)
	const [mounted, setMounted] = useState(true)
	const startRef = useRef(Date.now())
	const hasExitedRef = useRef(false)

	const beginExit = () => {
		if (hasExitedRef.current) return
		hasExitedRef.current = true

		const elapsed = Date.now() - startRef.current
		const remaining = Math.max(0, MIN_DISPLAY_MS - elapsed)

		window.setTimeout(() => setExiting(true), remaining)
	}

	useEffect(() => {
		if (pageLoaded) return

		const onLoad = () => setPageLoaded(true)
		window.addEventListener('load', onLoad)
		return () => window.removeEventListener('load', onLoad)
	}, [pageLoaded])

	useEffect(() => {
		if (pageLoaded && grainientReady) {
			beginExit()
		}
	}, [pageLoaded, grainientReady])

	useEffect(() => {
		const maxTimer = window.setTimeout(beginExit, MAX_DISPLAY_MS)
		return () => window.clearTimeout(maxTimer)
	}, [])

	useEffect(() => {
		if (!exiting) return

		const unmountTimer = window.setTimeout(() => {
			setMounted(false)
			onExit?.()
		}, FADE_MS)
		return () => window.clearTimeout(unmountTimer)
	}, [exiting, onExit])

	if (!mounted) return null

	return (
		<div
			className={`loading-screen${exiting ? ' loading-screen--exit' : ''}`}
			role='status'
			aria-live='polite'
			aria-label={t(language, 'loading.ariaLabel')}
		>
			<div
				className='loading-screen__glow'
				aria-hidden='true'
			/>

			<div className='loading-screen__content'>
				<div className='loading-screen__logo-wrap'>
					<div
						className='loading-screen__logo-ring'
						aria-hidden='true'
					/>
				<Logo
					alt=''
					className='loading-screen__logo'
					width={76}
					height={76}
					decoding='async'
				/>
				</div>

				<p className='loading-screen__name'>
					Rodrigo{' '}
					<span className='loading-screen__name-accent'>
						Alvarez Teytud
					</span>
				</p>
				<p className='loading-screen__tagline'>{t(language, 'loading.tagline')}</p>

				<div
					className='loading-screen__bar'
					aria-hidden='true'
				>
					<span className='loading-screen__bar-fill' />
				</div>
			</div>
		</div>
	)
}

export default LoadingScreen
